
























































import { Component, Vue, Inject, Watch, Prop } from 'vue-property-decorator';
import { MessageController } from '@/services/request.service';
import { fileUploader } from '@/services/qiniu.service.new';
// import { QuillEditor } from './quill-vue/quillEditor';
import { SimditorVue } from './simditor/Simditor';
import Textarea from '@/components/Textarea.vue';
import moment from 'moment';
import { saveAs } from 'file-saver';

@Component({
  components: {
    Textarea,
    SimditorVue,
  },
})
export default class SendMessageForm extends Vue {
  @Prop({ default: 'send' }) public mode!: string;
  @Prop({ default: () => {} }) public baseMsgInfo!: any;
  public messageForm: any;
  public recipent: any = {};
  public visibleOfModal: boolean = false;
  public loading: boolean = false;
  public content: string = '';
  public moment = moment;
  public uploadFileList: Array<any> = [];
  public MAXFILECOUNT = 10;
  public followingContentTotal: number = 2000;
  public followingContentNow: number = 0;
  public isSend: boolean = false;
  public fileNum: number = 0;
  public formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 6 },
      lg: { span: 6 },
      xl: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 10 },
      lg: { span: 10 },
      xl: { span: 10 },
    },
  };

  public beforeCreate(): void {
    this.messageForm = this.$form.createForm(this);
  }

  @Watch('mode', { immediate: true })
  public getMode(): void {
    this.isSend = false;
    if (this.mode === 'reply') {
      this.$nextTick(() => {
        this.messageForm.setFieldsValue({
          title: 'RE: ' + this.baseMsgInfo.title,
        });
      });
    } else if (this.mode === 'send') {
      this.recipent = {
        name: this.$route.query.teacherName,
        enName: this.$route.query.teacherEnName,
        memberId: this.$route.query.memberId,
      };
    }
  }

  public get locale(): string {
    return this.$i18n.locale;
  }

  public get routes(): any {
    const router = this.$route as any;
    return router.matched.filter((item: any) => item.meta && item.meta.routerName);
  }

  public beforeUpload(file: any) {
    const i = file.name.lastIndexOf('.');
    const suffix = file.name.slice(i).toLowerCase();
    const suffixArray = ['.png', '.jpg', '.jpeg', '.doc', '.docx', '.pdf', '.xls', '.xlsx'];
    if (!suffixArray.includes(suffix)) {
      this.$message.error(this.$tc('fileTypeErr'));
    } else if (file.size > 10 * 1024 * 1024) {
      this.$message.error(this.$tc('fileSizeErr'));
    } else if (this.fileNum >= this.MAXFILECOUNT) {
      this.$message.error(this.$tc('attachmentTip'));
    } else {
      this.fileNum += 1;
      this.uploadFile(file);
    }
    return false;
  }

  public handleReset(): void {
    const key = 'cancel';
    if (this.$listeners[key]) {
      this.$emit('cancel', false);
    } else {
      this.$router.back();
    }
  }

  public changeContent(val: any): void {
    this.content = val;
  }

  public uploadFile(file: any): void {
    const i = file.name.lastIndexOf('.');
    const suffix = file.name.slice(i).toLowerCase();
    const suffixArray = ['.png', '.jpg', '.jpeg', '.doc', '.docx', '.pdf', '.xls', '.xlsx'];
    if (suffixArray.includes(suffix)) {
      fileUploader(file, file.name)
        .then(res => {
          this.uploadFileList.push(res);
        })
        .catch(() => {});
    } else {
      this.$message.error(this.$tc('fileTypeErr'));
    }
  }

  public sendMessage(e: Event): void {
    e.preventDefault();
    this.messageForm.validateFieldsAndScroll((err: any, values: any) => {
      if (!err && !this.loading) {
        if (this.mode === 'send' && JSON.stringify(this.recipent) === '{}') {
          this.$message.error(this.$tc('selectRecipient'));
        } else if (!this.content) {
          this.$message.error(this.$tc('warningTip.contentNotEmpty'));
        } else {
          this.loading = true;
          this.sendFun(values);
        }
      }
    });
  }

  public sendFun(values: any): void {
    const key = 'ok';
    if (this.$listeners[key]) {
      values.attachments = this.uploadFileList;
      values.content = this.content;
      values.studentId = this.baseMsgInfo.toMemberId;
      values.messageParentId = this.baseMsgInfo.messageId;
      this.$emit('ok', values);
    } else {
      values.studentId = this.$route.query.id;
      values.memberIds = [this.recipent.memberId];
      values.attachments = this.uploadFileList;
      values.content = this.content;
      MessageController.sentMessageBatch(values)
        .then(res => {
          this.$message.success(this.$tc('sendSuccess'));
          this.$emit('change', true);
          this.isSend = true;
          this.$router.go(-1);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  public changeVisible(flag: boolean): void {
    this.visibleOfModal = flag;
  }

  public deleteFile(file: any) {
    let index1 = -1;
    for (const item in this.uploadFileList) {
      if (this.uploadFileList[item].uid === file.uid) {
        index1 = Number(item);
        break;
      }
    }
    if (index1 !== -1) {
      this.uploadFileList.splice(index1, 1);
    }
  }

  public downloadFile(file: any) {
    let index2 = -1;
    for (const item in this.uploadFileList) {
      if (this.uploadFileList[item].uid === file.uid) {
        index2 = Number(item);
        break;
      }
    }
    if (index2 !== -1) {
      saveAs(this.uploadFileList[index2].resourceUrl, this.uploadFileList[index2].name);
    }
  }
}
